export default "__VITE_ASSET__DN4a_640__"